module.exports = __webpack_public_path__ + "img/dp_lp_pc_bg_1.53cd0593.jpg";